import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";

const UploadDataViewModal = ({
  show,
  onHide,
  data = [],
  columns = [],
  title = "Uploaded Data Preview",
  file,
  onClick,
  disabled = false,
  loading = false,
}) => {
  const handleSave = () => {
    if (typeof onClick === "function") {
      onClick(file);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <DataTable
              columns={columns}
              data={data}
              pagination
              persistTableHead
              responsive
              striped
              highlightOnHover
            />
          </Col>
        </Row>
        {/* <div className="d-flex justify-content-end mt-3">
          {/* <button className="btn btn-success" onClick={handleSave}>
            Save
          </button> */}
        {/* </div> */} 
        <div className="d-flex justify-content-end mt-3">
          <button
            className="btn btn-success"
            onClick={handleSave}
            disabled={disabled || loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UploadDataViewModal;


// import React from "react";
// import { Modal, Row, Col } from "react-bootstrap";
// import DataTable from "react-data-table-component";

// const UploadDataViewModal = ({
//   show,
//   onHide,
//   data = [],
//   columns = [],
//   title = "Uploaded Data Preview",
//   file,
//   onClick,
//   disabled = false,
//   loading = false,
// }) => {
//   const handleSave = () => {
//     if (typeof onClick === "function") {
//       onClick(file);
//     }
//   };

//   return (
//     <Modal show={show} onHide={onHide} size="xl" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>{title}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Row>
//           <Col xs={12}>
//             <DataTable
//               columns={columns}
//               data={data}
//               pagination
//               persistTableHead
//               responsive
//               striped
//               highlightOnHover
//             />
//           </Col>
//         </Row>
//         <div className="d-flex justify-content-end mt-3">
//           <button
//             className="btn btn-success"
//             onClick={handleSave}
//             disabled={disabled || loading}
//           >
//             {loading ? (
//               <>
//                 <span
//                   className="spinner-border spinner-border-sm me-2"
//                   role="status"
//                   aria-hidden="true"
//                 ></span>
//                 Saving...
//               </>
//             ) : (
//               "Save"
//             )}
//           </button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UploadDataViewModal;
